module.exports = __webpack_public_path__ + "static/img/vouchers15010.8017c4ec.png";